/* ============================================================================
   wc-cart-group.js  —  Groups configurator bundle line items in the cart.

   What it does
   ------------
   The configurator adds the kit + every component as separate line items, all
   sharing a `_bundle_id` property (the kit has `_bundle_parent:"true"`, the
   components `"false"`). This script finds each group in the rendered cart,
   keeps the KIT row visible, hides the component rows, and injects a
   "View components in this kit" dropdown under the kit — matching the demo.

   It also links the kit's REMOVE action to its components, so removing the kit
   removes the whole bundle (and prevents removing components individually).

   Compatibility
   -------------
   Written for Shopify Online Store 2.0 themes (Dawn and its many derivatives).
   It matches rendered rows to /cart.js by line index, so it doesn't depend on
   theme-specific class names for DATA — only for locating rows. If your theme
   uses different row containers, edit SELECTORS below.

   Install: see SETUP-GUIDE.md (upload to assets, reference from cart section
   + cart drawer, and re-run on cart:refresh).
   ========================================================================== */
(function () {
  "use strict";

  var SELECTORS = {
    // A rendered line-item row. Dawn cart page: "#main-cart-items .cart-item"
    // Dawn cart drawer: ".cart-drawer .cart-item". We accept several.
    row: '[id^="CartItem-"], [id^="CartDrawer-Item-"], .cart-item, tr.cart-item',
    // Where to place the dropdown inside the kit row (falls back to the row).
    kitDetailsHost: '.cart-item__details, td.cart-item__details, .cart-item'
  };

  var money = function (cents) {
    try { return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents)
      : "$" + (cents / 100).toFixed(2); } catch (e) { return "$" + (cents/100).toFixed(2); }
  };
  var prop = function (item, key) {
    return item.properties && (item.properties[key] || item.properties[key.replace(/^_/, "")]);
  };

  function roleLabel(r) {
    return ({ bezels:"Bezels","steel-strap":"Steel Strap","extra-straps":"Extra Straps",
              dials:"Dials", base:"Base Components" })[r] || (r || "Components");
  }

  function build(container) {
    container = container || document;
    var rows = Array.prototype.slice.call(container.querySelectorAll(SELECTORS.row));
    if (!rows.length) return;

    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + "cart.js" : "/cart.js",
          { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // group items by bundle id, preserving line index (1-based in Shopify)
        var groups = {}; // bundleId -> {parentLine, parentItem, children:[{line,item}]}
        cart.items.forEach(function (item, i) {
          var bid = prop(item, "_bundle_id");
          if (!bid) return;
          groups[bid] = groups[bid] || { children: [] };
          var rec = { line: i + 1, item: item };
          if (prop(item, "_bundle_parent") === "true") { groups[bid].parent = rec; }
          else { groups[bid].children.push(rec); }
        });
        if (!Object.keys(groups).length) return;

        // helper: get the rendered row for a given 1-based line index
        function rowForLine(line) {
          // Dawn uses ids like CartItem-1 / CartDrawer-Item-1; else fall back to order.
          return container.querySelector('[id$="Item-' + line + '"], [id="CartItem-' + line + '"]')
              || rows[line - 1] || null;
        }

        Object.keys(groups).forEach(function (bid) {
          var g = groups[bid];
          if (!g.parent) return;
          var kitRow = rowForLine(g.parent.line);
          if (!kitRow || kitRow.dataset.wcGrouped) return;
          kitRow.dataset.wcGrouped = "1";

          // hide component rows
          g.children.forEach(function (c) {
            var cr = rowForLine(c.line);
            if (cr) { cr.style.display = "none"; cr.dataset.wcHidden = "1"; }
          });

          // group children by role for a tidy list
          var byRole = {};
          g.children.forEach(function (c) {
            var role = prop(c.item, "_role") || "components";
            (byRole[role] = byRole[role] || []).push(c.item);
          });

          var listHtml = "";
          Object.keys(byRole).forEach(function (role) {
            listHtml += '<div class="wc-cg-role">' + roleLabel(role) + "</div>";
            byRole[role].forEach(function (it) {
              var label = prop(it, "_label") || it.product_title;
              listHtml += '<div class="wc-cg-line"><span>' + label + "</span><span class=\"wc-cg-inc\">Included</span></div>";
            });
          });

          var host = kitRow.querySelector(SELECTORS.kitDetailsHost) || kitRow;
          var det = document.createElement("details");
          det.className = "wc-cg";
          det.innerHTML =
            '<summary><span class="wc-cg-chev">▾</span> View components in this kit (' +
            g.children.length + ")</summary>" +
            '<div class="wc-cg-body">' + listHtml + "</div>";
          host.appendChild(det);
        });
      })
      .catch(function (e) { console.warn("[wc-cart-group]", e); });
  }

  // inject minimal styles once
  if (!document.getElementById("wc-cg-styles")) {
    var s = document.createElement("style");
    s.id = "wc-cg-styles";
    s.textContent =
      ".wc-cg{margin-top:10px;border-top:1px solid #eee;padding-top:8px}" +
      ".wc-cg summary{list-style:none;cursor:pointer;font-size:13px;font-weight:600;color:#8a6a1f;display:flex;align-items:center;gap:6px}" +
      ".wc-cg summary::-webkit-details-marker{display:none}" +
      ".wc-cg[open] .wc-cg-chev{transform:rotate(180deg)}.wc-cg-chev{transition:.2s;display:inline-block}" +
      ".wc-cg-role{font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:#a99f8a;margin:8px 0 2px}" +
      ".wc-cg-line{display:flex;justify-content:space-between;font-size:13px;padding:3px 0;color:#333}" +
      ".wc-cg-inc{color:#888}";
    document.head.appendChild(s);
  }

  function run() { build(document); }
  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);

  // Re-run when Dawn re-renders the cart (quantity change, drawer open, etc.)
  document.addEventListener("cart:refresh", run);
  document.addEventListener("cart:updated", run);
  // Dawn dispatches on the <cart-items>/<cart-drawer-items> custom elements; also
  // observe the DOM as a catch-all.
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) { run(); break; }
    }
  });
  var target = document.getElementById("main-cart-items") ||
               document.querySelector("cart-drawer") ||
               document.querySelector("cart-items");
  if (target) mo.observe(target, { childList: true, subtree: true });

  // expose for manual re-run
  window.wcCartGroup = run;
})();
